// extracted by mini-css-extract-plugin
module.exports = {"label":"LinkWithChevron_label__TUXSl","hasSpacing":"LinkWithChevron_hasSpacing__14QAC","renderArrow":"LinkWithChevron_renderArrow__trEJ3"};